import { render } from "./password.vue?vue&type=template&id=ae8f375c&scoped=true"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"

import "./password.vue?vue&type=style&index=0&id=ae8f375c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\admin-tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae8f375c"]])

export default __exports__